import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { PubSubService } from '@libs/portal-common/system';

import { HttpClient } from '@angular/common/http';
import { AuditHelper } from './audit.helper';

@Injectable({ providedIn: 'root' })
export class LotIssuesService {
  constructor(
    private _httpClient: HttpClient,
    private _pubSubService: PubSubService,
  ) {}
  readonly section: string = 'Rules/Issues';

  // Get all LotIssues for the specified problem
  getAllForProblem(problemId): Observable<any> {
    return this._httpClient.get<any>('LotIssues?ProblemId=' + problemId);
  }

  // Get all LotIssues for the specified lot
  getAllForLot(lotId): Observable<any> {
    return this._httpClient.get('LotIssues?LotId=' + lotId);
  }

  // Get a LotIssue
  get(lotIssueId): Observable<any> {
    return this._httpClient.get<any>('LotIssues/' + lotIssueId);
  }

  // Create a LotIssue
  create(lotIssue): Observable<any> {
    return this._httpClient
      .put<any>(
        'LotIssues/',
        { lotIssue },
        {
          headers: AuditHelper.createAuditHeader({ entityId: lotIssue.fkLot, section: this.section }),
        },
      )
      .pipe(tap((response) => this._pubSubService.$pub('lotIssuesChanged', lotIssue.Id)));
  }

  // Update a LotIssue
  update(lotIssue): Observable<any> {
    return this._httpClient
      .put<any>(
        'LotIssues/',
        { lotIssue },
        {
          headers: AuditHelper.createAuditHeader({ entityId: lotIssue.fkLot, section: this.section }),
        },
      )
      .pipe(tap((response) => this._pubSubService.$pub('lotIssuesChanged', lotIssue.Id)));
  }

  // Delete a LotIssue
  delete(lotIssue): Observable<any> {
    return this._httpClient
      .delete<any>('LotIssues/' + lotIssue.Id, {
        headers: AuditHelper.createAuditHeader({ entityId: lotIssue.fkLot, section: this.section }),
      })
      .pipe(tap((response) => this._pubSubService.$pub('lotIssuesChanged', lotIssue.Id)));
  }
}
